import styled from 'styled-components';

export const CellRowContent = styled.div`
  display: flex;
  align-items: center;
`;
